import{detect as r}from"detect-browser";var e=r();export{e as browser};
